import { render, staticRenderFns } from "./VettingRecipes.vue?vue&type=template&id=f3cbc4f6&scoped=true"
import script from "./VettingRecipes.vue?vue&type=script&lang=js"
export * from "./VettingRecipes.vue?vue&type=script&lang=js"
import style0 from "./VettingRecipes.vue?vue&type=style&index=0&id=f3cbc4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cbc4f6",
  null
  
)

export default component.exports